// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const analyticsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardAnalytics: builder.query({
      query: ({ eventType, startDate, endDate, state }) =>
        `/api/v1/admin/analytics/dashboard-analytics?eventType=${eventType}&startDate=${startDate}&endDate=${endDate}&state=${state}`,
    }),
    getExportAnalytics: builder.mutation({
      query: ({ startDate, endDate, state }) => ({
        url: `/api/v1/admin/analytics/export-dashboard-analytics?&startDate=${startDate}&endDate=${endDate}&state=${state}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetDashboardAnalyticsQuery, useGetExportAnalyticsMutation } =
  analyticsApiSlice;
